import React, { FunctionComponent, useState } from 'react'
import useTranslation from '../../hooks/useTranslation'
import style from './fastConfigurationButton.css'
import FastConfigurationModal from '../fast-configuration-modal'
import FastConfigurationIcon from '../../assets/media/icons/fast-configuration.svg'
export type Props = {
    isVisible: boolean
    isDisabled: boolean
}

const FastConfigurationButton: FunctionComponent<Props> = (props) => {
    const modalActiveState = useState(false)
    const { isVisible, isDisabled } = props
    const { t } = useTranslation()

     if (!isVisible) {
        return null
    }

    const clickHandler = (): void => {
        const setModalIsActive = modalActiveState[1]

        setModalIsActive(true)
    }

    return (
        <>
            <button
                onClick={clickHandler}
                className={style.button}
                type="button"
                data-testid="fast-configuration-button"
                disabled={isDisabled}
            >
                <FastConfigurationIcon />
                {t('fastConfigurationModal.title')}
            </button>
            <FastConfigurationModal activeState={modalActiveState}/>
        </>
    )
}

export default FastConfigurationButton
